// MT WOMO Blog Custom Cursor Script
(function() {
  'use strict';
  
  // Check if device supports hover
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    return;
  }

  class WomoBlogCursor {
    constructor(section) {
      this.section = section;
      this.cursor = null;
      this.currentX = 0;
      this.currentY = 0;
      this.targetX = 0;
      this.targetY = 0;
      this.ease = 0.15;
      this.animationFrame = null;
      this.isActive = false;
      
      this.init();
    }

    init() {
      this.createCursor();
      this.bindEvents();
    }

    createCursor() {
      this.cursor = document.createElement('div');
      this.cursor.className = 'mt-womo-blog-cursor';
      
      this.cursor.innerHTML = `
        <svg class="mt-womo-blog-cursor__icon-circle" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="30" cy="30" r="29" stroke="white" stroke-width="2"/>
        </svg>
        <svg class="mt-womo-blog-cursor__icon-left" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="30" cy="30" r="29" stroke="white" stroke-width="1"/>
         <path d="M31.1396 24.1931C30.9701 23.9752 30.6564 23.9358 30.4385 24.1052L21.4385 31.1052C21.3167 31.2 21.2451 31.3455 21.2451 31.4998C21.2451 31.654 21.3167 31.7996 21.4385 31.8943L30.4385 38.8943C30.6564 39.0637 30.9701 39.0243 31.1396 38.8064C31.3091 38.5884 31.2697 38.2747 31.0518 38.1052L23.2021 31.9998H39.5C39.776 31.9996 40 31.7758 40 31.4998C39.9999 31.2237 39.776 30.9999 39.5 30.9998H23.2021L31.0518 24.8943C31.2697 24.7248 31.3091 24.4111 31.1396 24.1931Z" fill="#F5F2EE"/>
        </svg>
        <svg class="mt-womo-blog-cursor__icon-right" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="30" cy="30" r="29" stroke="white" stroke-width="1"/>
         <path fill-rule="evenodd" clip-rule="evenodd" d="M30.8604 24.1933C31.0299 23.9754 31.3436 23.936 31.5615 24.1055L40.5615 31.1055C40.6832 31.2002 40.7549 31.3457 40.7549 31.5C40.7548 31.6542 40.6832 31.7998 40.5615 31.8945L31.5615 38.8945C31.3436 39.0638 31.0298 39.0244 30.8604 38.8066C30.691 38.5887 30.7304 38.275 30.9482 38.1055L38.7979 32H22.5C22.224 31.9999 22.0001 31.776 22 31.5C22 31.2239 22.224 31.0001 22.5 31H38.7979L30.9482 24.8945C30.7304 24.7251 30.6911 24.4113 30.8604 24.1933Z" fill="#F5F2EE"/>
        </svg>
      `;
      
      document.body.appendChild(this.cursor);
    }

    bindEvents() {
      // Blog card links
      const cardLinks = this.section.querySelectorAll('.mt-womo-blog__card-link');
      cardLinks.forEach(link => {
        link.addEventListener('mouseenter', () => this.showCursor('circle'));
        link.addEventListener('mouseleave', () => this.hideCursor());
      });

      // Pagination buttons (prev/next)
      const prevButtons = this.section.querySelectorAll('.mt-womo-blog__pagination-prev');
      const nextButtons = this.section.querySelectorAll('.mt-womo-blog__pagination-next');
      
      prevButtons.forEach(btn => {
        btn.addEventListener('mouseenter', () => this.showCursor('left'));
        btn.addEventListener('mouseleave', () => this.hideCursor());
      });
      
      nextButtons.forEach(btn => {
        btn.addEventListener('mouseenter', () => this.showCursor('right'));
        btn.addEventListener('mouseleave', () => this.hideCursor());
      });

      // Pagination number buttons
      const pageButtons = this.section.querySelectorAll('.mt-womo-blog__pagination-btn:not(.mt-womo-blog__pagination-prev):not(.mt-womo-blog__pagination-next)');
      pageButtons.forEach(btn => {
        btn.addEventListener('mouseenter', () => this.showCursor('circle'));
        btn.addEventListener('mouseleave', () => this.hideCursor());
      });

      // Category filter labels (sidebar)
      const categoryLabels = this.section.querySelectorAll('.mt-womo-blog__category-label');
      categoryLabels.forEach(label => {
        label.addEventListener('mouseenter', () => this.showCursor('circle'));
        label.addEventListener('mouseleave', () => this.hideCursor());
      });

      // Mobile filter labels
      const filterLabels = this.section.querySelectorAll('.mt-womo-blog__filter-label');
      filterLabels.forEach(label => {
        label.addEventListener('mouseenter', () => this.showCursor('circle'));
        label.addEventListener('mouseleave', () => this.hideCursor());
      });

      // Filter button
      const filterBtn = this.section.querySelector('.mt-womo-blog__filter-btn');
      if (filterBtn) {
        filterBtn.addEventListener('mouseenter', () => this.showCursor('circle'));
        filterBtn.addEventListener('mouseleave', () => this.hideCursor());
      }

      // Filter close button
      const filterClose = this.section.querySelector('.mt-womo-blog__filter-close');
      if (filterClose) {
        filterClose.addEventListener('mouseenter', () => this.showCursor('circle'));
        filterClose.addEventListener('mouseleave', () => this.hideCursor());
      }

      // Mouse move
      document.addEventListener('mousemove', (e) => this.updateCursorPosition(e));
    }

    showCursor(type) {
      this.isActive = true;
      this.updateCursorIcon(type);
      this.cursor.classList.add('active');
      
      if (!this.animationFrame) {
        this.animate();
      }
    }

    hideCursor() {
      this.isActive = false;
      this.cursor.classList.remove('active');
    }

    updateCursorIcon(type) {
      // Remove all icon classes
      this.cursor.classList.remove('show-circle', 'show-left', 'show-right');
      
      // Add appropriate class
      if (type === 'circle') {
        this.cursor.classList.add('show-circle');
      } else if (type === 'left') {
        this.cursor.classList.add('show-left');
      } else if (type === 'right') {
        this.cursor.classList.add('show-right');
      }
    }

    updateCursorPosition(e) {
      this.targetX = e.clientX;
      this.targetY = e.clientY;
    }

    animate() {
      // Lerp animation for smooth following
      this.currentX += (this.targetX - this.currentX) * this.ease;
      this.currentY += (this.targetY - this.currentY) * this.ease;

      this.cursor.style.left = `${this.currentX}px`;
      this.cursor.style.top = `${this.currentY}px`;

      this.animationFrame = requestAnimationFrame(() => this.animate());
    }
  }

  // Initialize for all MT WOMO Blog sections
  function initWomoBlogCursors() {
    const sections = document.querySelectorAll('.mt-womo-blog');
    sections.forEach(section => {
      new WomoBlogCursor(section);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWomoBlogCursors);
  } else {
    initWomoBlogCursors();
  }

  // Handle Shopify theme editor
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      if (event.target.querySelector('.mt-womo-blog')) {
        initWomoBlogCursors();
      }
    });
  }
})();
